// DEV-12312: content-shaped loading state (canon skeleton, m3/_skeleton.scss) for
// every DataTable initialized with processing: true. The DataTables library loads
// AFTER this file (per-page via load_cdn_script → $extra_scripts), so defaults can't
// be extended here; instead rewrite each table's .dataTables_processing overlay on
// its preInit.dt event — a plain delegated jQuery event that only needs jQuery now.
// jQuery runs in noConflict as am.$ (head.tpl), so window.jQuery never exists.
if (window.am && am.$) {
	am.$(document).on('preInit.dt', function (e, settings) {
		// spans, not divs: jquery.dataTables.css styles div.dataTables_processing's
		// nested DIVs as its blue ellipsis dots — spans dodge that selector, and the
		// skeleton classes set display themselves so the element tag doesn't matter
		var skeleton =
			'<span class="am-skeleton-stack">' +
				'<span class="am-skeleton am-skeleton--line"></span>' +
				'<span class="am-skeleton am-skeleton--line am-skeleton--w-75"></span>' +
				'<span class="am-skeleton am-skeleton--line am-skeleton--w-60"></span>' +
			'</span>';
		am.$('div.dataTables_processing', settings.nTableWrapper).html(skeleton);
		// the "Loading..." row an ajax-sourced table draws in its tbody while the first
		// load is in flight — same skeleton, so the two built-in treatments can't stack
		settings.oLanguage.sLoadingRecords = skeleton;
	});
	am.$(document).on('processing.dt', function (e, settings, processing) {
		if (processing && typeof am_skeleton_takeover === 'function') am_skeleton_takeover();
	});
}

function get_func_obj(str, event){
	var arr = str.split(/,(?![^()]*\))/g); // split string into array by commas not to include inside ();
		arr.push(event.type) // sets reset value of original event listener
	const obj = {};
	
	const keyModifications = {
		0: "cbe", // new Event Listener
		1: "func", // function
		2: "eventReset" // original Event Listener
	};

	for (let i = 0; i < arr.length; i++) {
		const value = arr[i].trim();
		const key = keyModifications[i] || i.toString();
		obj[key] = value;
	}
	return obj;
}

function is_row_action($btn, role){
	if(role === 'delete')
		return $btn.hasClass('js-row-delete') || $btn.hasClass('fa-trash');
	return $btn.hasClass('js-row-save') || $btn.hasClass('js-row-cancel') || $btn.hasClass('fa-check') || $btn.hasClass('fa-xmark');
}

function toggle_action_buttons($tr, type){		
		var action_buttons = get_tr_buttons($tr);
		action_buttons.each((i, btn) => {
			var $btn = am.$(btn);
			if(!type){
				if(is_row_action($btn, 'edit')){
					$btn.show();
				}else{
					$btn.hide();
				}
			}else{
				if(is_row_action($btn, 'delete')){
					$btn.show();
				}else{
					$btn.hide();
				}
			}
		})
}

function get_tr_buttons($tr){
	var buttons = $tr.find('.js-action-btns > button');
	return buttons;
}

function get_tr($ele){
	var $tr = $ele.parent().closest('tr');
	return $tr;
}

function get_tr_checkmark($tr){
	var check = $tr.find('.js-action-btns > button.js-row-save, .js-action-btns > button.fa-check');
	return check;
}

function grayed_out_on_new($ele){
	// am.$('#js-save-page').prop('disabled', true);
	var $tr = get_tr($ele);
	disable_all_other_trs($tr)
	$ele.focus();
}

function enable_all_trs($tr){
	const $add_button = am.$('.am-add-button-cont').children('button');
	if($add_button.length > 0 && $add_button.hasClass('am-button-outline-dotted--grey') || $add_button.prop('disabled'))
		$add_button.removeClass('am-button-outline-dotted--grey ').prop('disabled', false);

	disable_all_other_trs($tr, true);
}

function disable_all_other_trs($tr, enable = false){
	const $tbody = $tr.parent().closest('tbody');
	const $table = $tbody.parent().closest('table');
	// const $thead = $table.children('thead'); 
	const $top = $table.siblings('.top');
	const $bottom = $table.siblings('.bottom');

	// finds add row section btn designated by '.js-add_row' class
	const $section = $table.parent().closest('.am-section-section');
	const $sib = $section.find('.am-add-button-cont');
	const $add_btn = $sib.find('.am-button-outline-dotted--grey');
	const $search_field =  $section.children('.dtable_quick_search_input_wrapper').children('input');

	var trs = $tbody.children('tr');

	trs.each((i, cur_tr) => {
		var $cur_tr = am.$(cur_tr);

		if(enable){
			$cur_tr.removeClass('grayed-out');
		}else if($cur_tr.attr('id') != $tr.attr('id') && !enable) {
			$cur_tr.addClass('grayed-out');
		}
		else if($cur_tr.attr('id') === $tr.attr('id') && !enable) {
			$cur_tr.addClass('active_tr');
		}
	})

	if(enable){
		update_add_btn_state($add_btn);
		$top.removeClass('grayed-out');
		// $thead.removeClass('grayed-out');
		$search_field.prop('disabled', false);
		$bottom.removeClass('grayed-out');

		if(am.$('#js-save-page').prop('disabled'))
			am.$('#js-save-page').prop('disabled', false)
	}else{
		update_add_btn_state($add_btn, true);
		$top.addClass('grayed-out');
		// $thead.addClass('grayed-out');
		$search_field.prop('disabled', true);
		$bottom.addClass('grayed-out');
		am.$('#js-save-page').prop('disabled', true)
	}
}

function convert_tr_elements(event, parent = false){
	var clicked_id = event.target.id; // saves focus elem id for target after element conversion

	if(event.target.classList.contains('fa-xmark') || event.target.classList.contains('js-row-cancel')){
		var $tr = get_tr(am.$(event.target));
		enable_all_trs($tr);
		toggle_action_buttons($tr, true);

		var $toggle = $tr.find('.am-switch');
		if($toggle.length > 0)
			$toggle.css({pointerEvents: "auto"}).parent().css({cursor: 'pointer'});
	}
	else{
		var element = document.querySelector("#"+event.target.id);
		var $tr = get_tr(am.$(element));
		disable_all_other_trs($tr);
		toggle_action_buttons($tr, false);

		var $toggle = $tr.find('.am-switch');
		if($toggle.length > 0)
		$toggle.css({pointerEvents: "none"}).parent().css({cursor: 'not-allowed'})
	}

	var $cm = get_tr_checkmark($tr);
	if(!$cm.prop('disabled')){
		$cm.prop('disabled', true)
	}

	var inputs = $tr.find('.js-toggle_input');

	inputs.each((i, inp) =>{
		var dataset = inp.dataset;
	
		var newElement = document.createElement(dataset.element);
		newElement.id = inp.id;
		newElement.classList = inp.classList;
		newElement.setAttribute('name', inp.getAttribute('name'));
	
		for (let j = 0; j < Object.keys(dataset).length; j++) {
			if(Object.keys(dataset)[j] === 'callback'){
				var cb_obj = get_func_obj(Object.values(dataset)[j], event);
				var func = new Function(cb_obj.func);
				
				if(event.target.classList.contains('fa-xmark') || event.target.classList.contains('js-row-cancel')){
					// assign callback event listener and function callback to new element created.
					if(cb_obj.cbe == 'onblur' || cb_obj.cbe == 'blur') 
						newElement.onblur = func;
					else if(cb_obj.cbe == 'onclick' || cb_obj.cbe == 'click')
						newElement.onclick = func;
					else if(cb_obj.cbe == 'onkeyup' || cb_obj.cbe == 'keyup')
						newElement.onkeyup = func;
					// else if (cb_obj.cbe == 'new event type here' ) Follow pattern for additional event types needed
				}
		
					var callbackStr = Object.values(dataset)[j].replace(cb_obj.cbe, 'on'+cb_obj.eventReset) // replace eventType with reset eventType. 
					newElement.setAttribute('data-callback', callbackStr);
			}
			else if(Object.keys(dataset)[j] === 'element'){
				newElement.setAttribute("data-" + Object.keys(dataset)[j], inp.tagName.toLocaleLowerCase());
			}
			else if (Object.keys(dataset)[j] === 'value'){
				newElement.setAttribute("data-" + Object.keys(dataset)[j], Object.values(dataset)[j]); // sets value for dataset object
	
				if(dataset.element === 'input'){ // sets Input || innerHTML value
					newElement.setAttribute(Object.keys(dataset)[j], Object.values(dataset)[j]);
					newElement.setAttribute('editable', true);
				}
				else{
					newElement.innerHTML = Object.values(dataset)[j];
					newElement.value = Object.values(dataset)[j];
				}
			}
			else if(Object.keys(dataset)[j] === 'placeholder'){
				if(dataset.element === 'input'){
					newElement.setAttribute('placeholder', Object.values(dataset)[j]);
					newElement.setAttribute('data-placeholder', Object.values(dataset)[j]);
				}else{
					newElement.setAttribute('data-placeholder', Object.values(dataset)[j]);
				}
			}
			else if(Object.keys(dataset)[j] === 'type'){
				newElement.setAttribute(Object.keys(dataset)[j], Object.values(dataset)[j]);
			}
			else if(Object.keys(dataset)[j] === 'validation'){
				newElement.setAttribute("data-" + Object.keys(dataset)[j], Object.values(dataset)[j]);
			}
			else{
				newElement.setAttribute("data-" + Object.keys(dataset)[j], Object.values(dataset)[j]);
			}
		}
	
		var $parent = parent ? am.$(inp).parent(parent) : am.$(inp).parent();
	
		if(newElement.getAttribute('data-currency')){
			var content = newElement.value;
			if(content.length > 0){
				const $cur_span = $parent.children('.js-currency-span');
				if(dataset.element == 'input'){
					$parent.append(`<span class="js-currency-span" style="padding-right: 5px;">${get_currency_symbol()}</span>`);
					newElement.addEventListener('keydown', (e) => onlyNumberKey(e) ); // Limits the addition of non numeric values where ONLY numeric values are M.Yandow
				}
				else if($cur_span.length > 0 && dataset.element == 'div'){
					$cur_span.remove();
				}
	
				if(newElement.getAttribute('data-req_formatting')){
					var rounded = decimal_check(content, 2);
					var formattedNumber = get_currency_format(rounded);
					content = formattedNumber;
				}
				newElement.innerHTML = `<span>${get_currency_symbol()}</span> ${content}`;
			}
		}
		
		$parent.append(newElement);
		// console.log(newElement, "new element") // best way to see Element details for debugging when toggled - M. Yandow
		am.$(inp).remove();
		newElement.id = inp.id;

		newElement.addEventListener('keyup', (e) => { 
			if(e.code == 'Enter' || e.key == 'Enter'){
				var $tr = get_tr(am.$(e.target))
				var $cm = get_tr_checkmark($tr);

				if(!$cm.prop('disabled')){
					var onenter = new Function($tr.attr('data-on-enter-existing'));
					onenter();
				}
			}
		})
	})

	document.on('keyup', '.js-toggle_input', (e) => {
		check_row_values_for_change(e, $tr);
	})

	var $primary_btn = am.$('#js-save-page'); // Generally will be save button but some pages might be more of a primary btn
	if(!(event.target.classList.contains('fa-xmark') || event.target.classList.contains('js-row-cancel'))){
		$primary_btn.prop('disabled', true);
		am.$(`#`+clicked_id).focus();
	}else{
		$primary_btn.prop('disabled', false);
	}
}

function on_new_row_enter($tr, selectors='input'){
	var inputs = $tr.children().find(selectors);
	inputs.each( (i, inp) => {
		inp.addEventListener('keyup', (e) => {
			if(e.code == 'Enter' || e.key == 'Enter'){
				var $cm = get_tr_checkmark($tr);
				if(!$cm.prop('disabled')){
					var onenter = new Function($tr.attr('data-on-enter-new'));
					onenter();
				}
			}
		})
	})
}
function annimateIcons($tr){
	const $el = $tr.find('.fa-trash');
	ensureGSAP().then(function(){
		const tl = gsap.timeline({ defaults: {duration: .2}, onComplete:function(){
			faSpinner($el, $tr);
		}})
		tl
			.to($tr, {pointerEvents: 'none'}, 'start')
			.to($el, {opacity: 0}, 'start')
	});
}
function faSpinner($el, $tr){
	$el.addClass('fa-duotone fa-spinner-third fa-spin').removeClass('fa-trash');
	const tl2 = gsap.timeline({ defaults: {duration: .5}, onComplete:function(){
		faCheck($el, $tr);
	}})
	tl2
		.to($el, {opacity: 1})
}
function faCheck($el, $tr){
	$el.addClass('fa-check fa-beat').removeClass('fa-duotone fa-spinner-third fa-spin');
	const tl3 = gsap.timeline({ defaults: {duration: .3}, onComplete:function(){
		faTrash($el, $tr);
	}})
	tl3
		.to($el, {opacity: 1, duration: .5 })
		.to($el, {opacity: 0})
}
function faTrash($el, $tr){
	$el.addClass('fa-trash').removeClass('fa-check');
	$tr.css({pointerEvents: 'auto'});
}

function data_table_processing_indecators($tr, spin = false){
	toggle_action_buttons($tr, true);

	if(spin)
		annimateIcons($tr);
}

function get_currency_format(price){
	const numStr = price.toString();
	  
	// Split the number into integer and decimal parts (if any)
	const [integerPart, decimalPart = ''] = numStr.split('.');
	  
	// Add commas as thousands separators to the integer part
	const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	  
	// Combine the integer and decimal parts back with a dot
	const formattedNumber = decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;

	return formattedNumber;
}

function check_row_values_for_change(e, $tr){
	var $cm = get_tr_checkmark($tr);

	if(e.target.value !== e.target.getAttribute('data-prev_state')){
		e.target.classList.add('js-add_chk_set')
		$cm.prop('disabled', false);
	}else{
		var inputs = $tr.find('.js-add_chk_set');
		var chk_arr = [];
		inputs.each((i, inp) => {
			var $inp = am.$(inp);
			if($inp.val() !== $inp.attr('data-prev_state')){
				$cm.prop('disabled', true);
			}else{
				chk_arr.push(true);
			}
		});

		if(chk_arr.length == inputs.length){
			$cm.prop('disabled', true);
		}
		else{
			$cm.prop('disabled', false);
		}
	}

	if(am.$(e.target).hasClass('js-add_api_key')){
		const $tr = am.$(e.target).parent().closest('tr');
		if($tr.children('.td-key').text().length == 0)
			$tr.children('.td-key').text(buildKey());
	}
}

function check_new_row_value(e){
	var number_chk = false;
	if(e.target.getAttribute('data-currency')){
		number_chk = onlyNumberKey(e, true);
	}else {
		number_chk = true;
	}

	if(number_chk){
		var $tr = get_tr(am.$(e.target));
		check_row_values_for_change(e, $tr)
	}
}

function onlyNumberKey(e, new_val = false) {
	var key = e.keyCode ? e.keyCode : e.which;
	var key_passes = true;
    if (!( [8, 9, 13, 27, 46, 110, 190].indexOf(key) !== -1 ||
         (key == 65 && ( e.ctrlKey || e.metaKey  ) ) || 
         (key >= 35 && key <= 40) ||
         (key >= 48 && key <= 57 && !(e.shiftKey || e.altKey)) ||
         (key >= 96 && key <= 105)
       )) {
		   e.preventDefault();
		   key_passes = false;
	   }

	if(new_val)
	   return key_passes;
	
}

function tr_input_check(e, convert_ele = 'td'){
	const $this = am.$(e.target);
	var $tr = get_tr($this);
	var $checkmark = get_tr_checkmark($tr);

	if($this.val() != $this.attr('prev_state')){
		convert_tr_elements(e, convert_ele);
	}else{
		$checkmark.show();
	}
}

function delete_tr_by_id(table_id, tr_id){
	const $table = am.$('#'+table_id);
	var $tr = am.$('#'+ tr_id);
	var $sib = $tr.siblings().closest('tr'); 

	if($sib.length > 0){
		$table.DataTable().row($tr).remove().draw();
		enable_all_trs($sib);
	}else{
		$table.DataTable().row($tr).remove().draw();
		const $add_button = am.$('.am-add-button-cont').children('button');
		$add_button.removeClass('am-button-outline-dotted--grey ').prop('disabled', false);
	}

}

function update_target_status(params, msg_obj){
	try{
		am.$.post(`/${params.ajax ? params.ajax : 'ajax'}/${params.path}/${params.url}/`, params, {
		})
		.then((res) => {
			show_snackbar({
				message: msg_obj.success,
				type: 'success'
			});

		})
		.fail((e) => {
			show_snackbar({
				message: msg_obj.fail,
				type: 'danger'
			});
		})
	}catch(e){
		console.log(e)
	}
}

function check_new_row_count(class_name){
	if(am.$('.' + class_name ).length == 0)
		am.$('.am-button-row-sticky').children('.am-btn--filled').prop('disabled', false)
}

function reset_row($tr, params, res){
	update_add_btn_state(get_tr_checkmark($tr), true);
	$tr.hide().removeClass(params.tr_designator + 'is_new').attr('is_new', false).attr('id', params.tr_designator + res.redraw_id).attr('data-id', res.redraw_id).fadeIn('fast');
}

function update_table_row(params, msg_obj = false, killModal = true){
	if(!msg_obj)
		get_std_msg_obj();

	var $tr = am.$(`#${params.tr_designator + params.id}`);
	var $table = $tr.parent().closest('table');

	data_table_processing_indecators($tr, true);
	console.log(`/${params.ajax ? params.ajax : 'ajax'}/${params.path}/${params.url}/`, "`/${params.ajax ? params.ajax : 'ajax'}/${params.path}/${params.url}/`")
	try{
		am.$.post(`/${params.ajax ? params.ajax : 'ajax'}/${params.path}/${params.url}/`, params, {
		})
		.then((res) => {
			var table = $table.DataTable();
			if(params.process != 'delete'){
				setTimeout(() => {
					if(table.context[0].ajax != null && table.context[0].ajax.url && table.context[0].ajax.url.includes('?search_val')){
						var resize = get_resize_object($table.attr('data-resize_key'));
						table.ajax.url( resize.url ).load(null, false);
					}else{
						table.row($tr).data(res).draw('page');
						reset_row($tr, params, res);
						check_new_row_count(params.tr_designator + 'is_new');
					}
					
					show_snackbar({
						message: msg_obj.msg_update.success,
						type: 'success'
					});
				},1000);
			}
			else{
				table.row($tr).remove().draw(false);
				show_snackbar({
					message: msg_obj.msg_delete.success,
					type: 'success'
				});
			}
			enable_all_trs($tr);
		})
		.fail((e) => {
			console.log(e);
			setTimeout(() => {
				if(params.process != 'delete'){
					show_snackbar({
						message: msg_obj.msg_update.fail,
						type: 'danger'
					});
				}else{
					show_snackbar({
						message: msg_obj.msg_delete.fail,
						type: 'danger'
					});
				}
			},1000);
		})
		.always(()=>{
			setTimeout(() => { 
				if(killModal) 
					kill_all_modal_elements(); 
			}, 250);
		})
	}catch(e){
		console.log(e)
	}
}

function setSearchFocus(t){
	am.$(t).siblings('.dt_search_input').focus();
}

function search_table(settings, cb=false){
	let delayTimer;
	$search = am.$('#' + settings.sTableId + '_search');
	$search.keyup(function(){
		const table =  am.$('#' + settings.sTableId).DataTable();
		var val = am.$(this).val();

		if(!cb){
			table.search(val).draw();
		}
		else{
			clearTimeout(delayTimer);
			delayTimer = setTimeout(() => { 
				if (!isNaN(val) && val.trim() !== '') {
					val = Number(val);
				} else {
					val = val.toLowerCase();
				}

				cb(table, val); 
			}, 1000);
		}
	});
}

function clearSearch(id){ // clears search input params on new row insert  
	const $search = am.$(id + '_search');
	if($search.length > 0 && $search.val() != ''){
		const table = am.$(id).DataTable();
		if(table.context[0].ajax.url && !table.context[0].ajax.url.includes('?search_val')){
			table.search('').draw();
			$search.val('');
		}
	}
}

function show_mobile_header_keys(settings){
	if(am.$(window).width() > 768) 
		return;

	const $dt = am.$('#'+settings.sTableId);
	if($dt.length == 0) return;

	var keys = $dt.find('.mobile-data-key');
	if(keys.length > 0){
		keys.each((i, el) => {
			am.$(el).show();
		})
	}
}

function toggle_pagination(oSettings){
	var hide = {all: true, search: true, header: true, rpp: true, info: true, arrows: true, debug:{cond:1,rpp:0,length:0}};
	const $tableWrapper = am.$(oSettings.nTableWrapper);
	const $t_header = am.$(oSettings.nTHead);
	const $search = am.$(`#${oSettings.sTableId}_quick_search_input_wrapper`);
	const rpp_count = oSettings._iDisplayLength ? oSettings._iDisplayLength : get_standard_rows_number_per_page();

	if(oSettings.aoData.length >= 1){
		if(oSettings.aoData.length == 1)
			hide = { search: false, arrows: true, header: false, info: true, debug:{cond:2, rpp:rpp_count,length:oSettings.aoData.length}}
		else if(oSettings.aoData.length > rpp_count)
			hide = oSettings.aiDisplay.length == 0 ? { all: true, debug:{cond:3, rpp:rpp_count,length:oSettings.aoData.length} } : { all: false, search: false, arrows: false, header: false, debug:{cond:4, rpp:rpp_count,length:oSettings.aoData.length}}
		else if(oSettings.aoData.length == rpp_count || oSettings.aoData.length > 1)
			hide = oSettings.aiDisplay.length == 0 ? { all: true, debug:{cond:5, rpp:rpp_count,length:oSettings.aoData.length} } : { all: false, search: false, arrows: true, header: false, info: false, debug:{cond:6, rpp:rpp_count,length:oSettings.aoData.length} }
		else
			hide = { all: true, search: false, arrows: true, debug:{cond:7, rpp:rpp_count,length:oSettings.aoData.length} }
	}
	else{
		hide = { all: true, debug:{cond:8, rpp:rpp_count,length:oSettings.aoData.length} };
	}
	console.log(hide); // Non sensetive data about what datatable UI should be/not be shown

	if($search.length > 0) // Not all tables contain search fields
		hide.search ? $search.hide() : $search.show();

	hide.header ? $t_header.addClass('hide') : $t_header.removeClass('hide');

	var t_b = $tableWrapper.children(`#top-${oSettings.sTableId}, #bottom-${oSettings.sTableId}`); // necessary for when we have pages containing more than 1 datatable
	if(t_b.length > 0){
		const target_strs = [ `dataTables_filter`, `dataTables_length`, `dataTables_info`, `dataTables_paginate` ];
		t_b.each((i, el) => {
			const sides = am.$(el).children(`.lside-info, .rside-info`);
			if(sides.length > 0){
				sides.each((i, side) => {
					target_strs.each((string) => {
						const $target = am.$(side).children(`.${string}`);
						if($target.length > 0){
							if(hide.all){
								am.$($target).addClass('hide')
								if(oSettings.sTableId == 'payment_history_table')
									am.$('#top-payment_history_table').hide();
							}
							else{ 
								// if(string == 'dataTables_filter') // Currently always hide default search input from datatable.

								if(string == 'dataTables_length')
									hide.rpp ? am.$($target).addClass('hide') : $target.removeClass('hide');

								if(string == 'dataTables_info')
									hide.info ? am.$($target).addClass('hide') : $target.removeClass('hide');

								if(string == 'dataTables_paginate')
									hide.arrows ? $target.addClass('hide') : $target.removeClass('hide');
							}
						}
					})
				})
			}
		})
	}
}

function is_checked(status){ // Used with slider
	var checked = '';
	if (status == 1)
        checked = ' checked ';

	return checked;
}

function toggle_specified_column(table_id, column = [], visibility = false){
	var table = am.$(table_id).DataTable();
    	table.column( column ).visible( visibility );
}

function format_date(date, type = 'MDY'){
	const originalDate = new Date(date);
	if(type === 'MDY'){
		var formattedDate = new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).format(originalDate);
	}
	else{
		return date;
	}
	return formattedDate;
}

function show_required_columns(t){
	const $this = am.$(t);
	let $t_head = $this.find('thead tr th.js-required-col');
	
	const $scroll_head =  $this.parent('.dataTables_scrollBody').siblings('.dataTables_scrollHead');
	if($scroll_head.length == 1)
		$t_head = $scroll_head.find('table thead tr th.js-required-col');

	$t_head.each((i, el) => {
		const $el = am.$(el);
		if($el.children('.req-astr').length == 0)
			$el.append('<span class="req-astr">*</span>');
	})
}

function show_error_msg_datatable_row({ target, msg = get_language_translation('REQUIRED_FIELD_LANG'), custom_section = false, ...options }){
	// Target - id/class of the input that requires a value, 
	// msg - is the error message to display

	const $el = am.$(target);
	var $td = $el.parent('td');
	$td.addClass('show-error')

	const $err_msg = $td.children('.error-msg');
	$el.addClass('am-error-border')

	var error_lable_id = `${target.replace('#', '')}_err_label`;
	$el.on('blur', () => {
		$td.removeClass('am-error-text show-error');
		$el.removeClass('am-error-border');
		am.$(target+'_err_label').remove();
	});

	if(options.set_focus)
		$el.focus();

	var textAlign = 'error-msg--start';
	if($td.hasClass('js-err-end'))
		textAlign = 'error-msg--end';

	else if($td.hasClass('js-err-start'))
		textAlign = 'text-left';
	else
		textAlign = 'text-center';

	
	if($err_msg.length == 0)
		$td.append(`<label id="${error_lable_id}" class="error-msg ${textAlign}"><i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i><span class="msg">${msg}</span></label>`);
	else if(msg != $err_msg.children('.msg').text())
		$err_msg.children('.msg').text(msg);
}

function buildTableSearch(id = '', placeholder = '', aux_class = ''){
    if(placeholder === '')
        placeholder = get_language_translation('LANG_NAVBAR_SEARCH');

		var output = `<div id="${id}_quick_search_input_wrapper" class="dtable_quick_search_input_wrapper ${aux_class}">
                    <input type="text" name="search_query" id="${id}_search" class="default dt_search_input" placeholder="${placeholder}" autocomplete="off" onclick="">
                    <button type="button" id="${id}_quick_search_button" class="dtable_quick_search_button" onclick="setSearchFocus(this);"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg></button>
                </div>`;


    return output;
}

function buildAddRow(func, aux_class = '', create_account = false){
	var ca_class = create_account ? 'am-add-dot' : '';
	
	var output = `<div class="am-add-button-cont ${aux_class}">
			<button type="button" class="am-button-outline-dotted--grey ${ca_class}" onclick=${func}>
				<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/></svg>
				<span> ${ get_language_translation('LANG_NAV_ADD_NEW') } </span>
			</button>
		</div>`;

	return output;
}

function replaceNullsWithDefualt(obj, defaultValue) {
	if (obj === null) {
	  return defaultValue;
	}
  
	if (Array.isArray(obj)) {
	  return obj.map(item => replaceNullsWithDefualt(item, defaultValue));
	}
  
	if (typeof obj === 'object' && obj !== null) {
	  for (var key in obj) {
		if (obj.hasOwnProperty(key)) {
		  obj[key] = replaceNullsWithDefualt(obj[key], defaultValue);
		}
	  }
	}
  
	return obj;
  }

// ------------------------------------------------------------- Style functions below this point --------------------------------------------
 
// DataTable Standard display, design, & layout below
	// NOTE: If further custom choices are built into current or future functions be sure to always have a defualt option - M. Yandow Jul, 25, 2023
function get_std_pagingType(){
	return am.$(window).width() > 768 ? 'full_numbers' : "simple_numbers";
}
 
function get_std_rpp(type, cust_length = 20){
	var arr = [[100, 10, 25, 50],[100, 10, 25, 50]]; // Default array
	if(typeof cust_length == 'object' ){
		arr = cust_length; // Custom array
	}
	else if(typeof cust_length == 'number' && type == 'short'){
		arr = [[cust_length, 50,20], [cust_length, 50, 100]] // Short array
	}

	return arr;
}
 
function get_std_paginate(cust_info = false, custlength = false){
	return {
	   paginate: {
			first: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"/></svg>',
			previous: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>',
			next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>',
			last: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.59 7.41 10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"/></svg>'
		},
		infoFiltered: "",
		info: !cust_info ? " _START_ - _END_ of _TOTAL_" : cust_info,
		lengthMenu: !custlength ? get_language_translation('LANG_ROWS_PER_PAGE')+" _MENU_" : custlength
	}
}
 
function get_std_info_cb(iStart, iEnd, iTotal){
	return '<span class="datatable_info_span">' + iStart + "-" + iEnd + " of " + iTotal + '</span>';
}
 
function get_std_oLanguage(translation_key, period = '.'){
	let var_msg = get_language_translation(translation_key);
	return {
	   sEmptyTable: '<div class="am-dataTable-no-data"><span>'+var_msg+period+'</span></div>',
	   sLengthMenu: get_language_translation('LANG_ROWS_PER_PAGE')+" _MENU_"
	}
}
 
function get_std_dom(id, style = false){
	var dom = id ? `<"#top-${id}.top"<"#lside-top.lside-info"fl><"#rside-top.rside-info"ip><"clear">>rt<"#bottom-${id}.bottom"<"#lside-bottom.lside-info"lf><"#rside-bottom.rside-info"ip><"clear">>` : '<"top"<"#lside-top.lside-info"fl><"#rside-top.rside-info"ip><"clear">>rt<"bottom"<"#lside-bottom.lside-info"lf><"#rside-bottom.rside-info"ip><"clear">>';
	
	if(style && style == 'none')
		dom = id ? `<"#top-${id}.top"<"clear">>t<"bottom"<"clear">>` : `<"top"<"clear">>t<"bottom"<"clear">>`;
	else if(style && style == 'bottom')
		dom = id ? '<"#top-${id}.top"f>rt<"bottom"lpi><"clear">' : '<"top"f>rt<"bottom"lpi><"clear">';
	else if(style && style == 'top')
		dom = 'lpt';

	return dom;
}

function get_standard_rows_number_per_page (){
	return 15;
}
